// removed by extract-text-webpack-plugin
module.exports = {"Link":"customLink__Link__2hP33"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/CustomLink/customLink.css
// module id = 888
// module chunks = 2